<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isSysAdmin()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
			<br>
			<div class="col-lg-12 overflow-auto">
				<div class="card card-danger card-outline">
					<div class="card-header">
						Problem Subtypes
						<button class="btn btn-danger float-right" @click="sync">Sync</button>
					</div>
					<div class="card-body overflow-auto">
						<table class="table table-striped table-bordered table-hover">
							<thead>
								<tr>
									<th>Sub Type</th>
									<th>Description</th>
									<th>Status</th>
									<th>Change</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="j in types" :key="j.id">
									<td>{{j.name}}</td>
									<td>{{j.description}}</td>
									<td>{{j.status}}</td>
									<td>
										<button class="btn btn-success fa fa-play" v-if="j.status == 'N'" @click="changeType(j.id)"></button>
										<button class="btn btn-danger fa fa-square" v-else-if="j.status == 'Y'" @click="changeType(j.id)"></button>
									</td>
								</tr>
							</tbody>
						</table>
		  		</div>
		  		<div class="card-footer">
		  			<div class="col-sm-12">
		  				<div class="row">
		  					<div :class="['form-group', errors.status ? 'has-error' : '']">
		  						<input type="text" class="form-control" v-model="name" placeholder="Enter new type">
		  						<span v-if="errors.name" :class="['badge bg-danger']">Please enter a valid type.</span>
		  					</div>
		  					<div :class="['form-group', errors.status ? 'has-error' : '']">
		  						<input type="text" class="form-control" v-model="description" placeholder="Enter new description">
		  						<span v-if="errors.description" :class="['badge bg-danger']">Please enter a valid description.</span>
		  					</div>
		  					<div class="form-group">
		  						<button class="btn btn-danger" @click="addType"><i class="fa fa-plus"></i> Add Description</button>
		  					</div>
		  				</div>
		  			</div>
					</div>
				</div>
			</div>
    </section>
    <!-- /.content -->

<loading :show="lshow" :label="llabel"> </loading>
    
<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isSysAdmin()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
import loading from "vue-full-loading";
		 export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        components: { loading },
        
        created(){
        	this.getTypes();
        },
        
        data(){
        	return {
        		types: [],
        		name: '',
        		description: '',
        		lshow: false,
        		llabel: 'Syncing...',
            errors:[]
        	}
        },
        
        methods: {
        	getTypes(){
        		axios.post("/api/getProblemSubtypes")
        		.then(response => {
        			this.types = response.data;
        		});
        	},
        	
        	addType(){
        		axios.post("/api/addProblemSubtype", {name: this.name, description: this.name})
        		.then(() => {
        			this.getTypes();
        		});
        	},
        	
        	changeType(id){
        		axios.post("/api/changeProblemSubtype", {id: id})
        		.then(() => {
        			this.getTypes();
        		});
        	},
        	
        	sync(){
        		this.lshow = true;
        		axios.post("/api/syncServiceProblemSubtypes")
        		.then(() => {
        			this.getTypes();
        		});
        		this.lshow = false;
        	}
        }
    }
</script>
